<template>
    <div v-if="dictionaryLoaded" class="formgrid grid">
        <div class="col-12">
            <div class="field">
                <label :for="getInputFieldName('WhatICan')">{{ dictionary.ArtistProfileFormWhatICanYoungLabel}}</label>
                <Textarea :name="getInputFieldName('WhatICan')" v-model="model.WhatICan"></Textarea>
            </div>
            <div class="field">
                <label :for="getInputFieldName('WhatIWant')">{{dictionary.ArtistProfileFormWhatIWantLabel}}</label>
                <Textarea :name="getInputFieldName('WhatIWant')" v-model="model.WhatIWant"></Textarea>
            </div>
            <div class="field">
                <label :for="getInputFieldName('YoutubeVideoUrl')">{{dictionary.ArtistProfileFormYoutubeLabel}}</label>
                <InputText :name="getInputFieldName('YoutubeVideoUrl')" :placeholder="dictionary.ArtistProfileFormYoutubePlaceholder" type="url" v-model="model.YoutubeVideoUrl" />
            </div>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import InputText from 'primevue/inputtext';
import Textarea from 'primevue/textarea';
import Toast from 'primevue/toast';
import Password from 'primevue/password';
import Checkbox from 'primevue/checkbox';
export default {
    name: "artistProfileYoungForm",
    props: ['profileModel','actionType','inputKey'],
    components: {
        Button,
        InputText,
        Textarea,
        Toast,
        Checkbox,
        Password
    },
    data() {
        return {
            dictionary: [],
            dictionaryLoaded: false,
            model: {
                WhatICan: null,
                WhatIWant:null,
                YoutubeVideoUrl: null,
            }
        };
    },
    created() {
        const vm = this;
        if(vm.profileModel) {
            vm.model = vm.profileModel;
        }

        fetch('/umbraco/api/resourcesApi/GetArtistProfileFormDictionary').then((response) => response.json())
            .then((data) => {
                vm.dictionary = data;
                vm.dictionaryLoaded = true;
            })
            .catch((error) => {
                console.log(error);
                vm.dictionaryLoaded = true;
            });
    },
    watch: {
        createStatus(newVal,oldVal){
            if(newVal != oldVal){
                this.$emit('createStatusUpdated',newVal);
            }
        }
    },
    computed: {
        createStatus() {
            const status = this.model.WhatICan != null && this.model.WhatICan.length > 0 ? true : false;
            return {
                key: this.inputKey,
                value: status
            };
        }
    },
    methods: {
        getInputFieldName(name) {
            if (this.inputKey) {
                return this.inputKey + '.' + name.charAt(0).toUpperCase() + name.slice(1);
            }

            return name;
        }
    }
};
</script>